import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-quantity-selector',
  templateUrl: './quantity-selector.component.html',
  styleUrls: ['./quantity-selector.component.scss'],
  standalone: false
})
export class QuantitySelectorComponent {
  @Input() label?: string;
  @Input() customClass: string = '';

  @Input() value: number = 1;
  @Input() min: number = 1;
  @Input() max: number = 99;
  @Output() valueChange = new EventEmitter<number>();
  
  increase() {
    if (this.value < this.max) {
      this.value++;
      this.valueChange.emit(this.value);
    }
  }

  decrease() {
    if (this.value > this.min) {
      this.value--;
      this.valueChange.emit(this.value);
    }
  }
}
